(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1609);

/***/ }),

/***/ 5448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var settle = __webpack_require__(6026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(5327);
var buildFullPath = __webpack_require__(4097);
var parseHeaders = __webpack_require__(4109);
var isURLSameOrigin = __webpack_require__(7985);
var createError = __webpack_require__(5061);
var defaults = __webpack_require__(5655);
var Cancel = __webpack_require__(5263);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 1609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var bind = __webpack_require__(1849);
var Axios = __webpack_require__(321);
var mergeConfig = __webpack_require__(7185);
var defaults = __webpack_require__(5655);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(5263);
axios.CancelToken = __webpack_require__(4972);
axios.isCancel = __webpack_require__(6502);
axios.VERSION = (__webpack_require__(7288).version);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(6268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 5263:
/***/ (function(module) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ 4972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(5263);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 6502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var buildURL = __webpack_require__(5327);
var InterceptorManager = __webpack_require__(782);
var dispatchRequest = __webpack_require__(3572);
var mergeConfig = __webpack_require__(7185);
var validator = __webpack_require__(4875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ 782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 4097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(1793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 5061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(481);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ 3572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var transformData = __webpack_require__(8527);
var isCancel = __webpack_require__(6502);
var defaults = __webpack_require__(5655);
var Cancel = __webpack_require__(5263);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 481:
/***/ (function(module) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),

/***/ 7185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 6026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(5061);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 8527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);
var defaults = __webpack_require__(5655);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 5655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(3454);


var utils = __webpack_require__(4867);
var normalizeHeaderName = __webpack_require__(6016);
var enhanceError = __webpack_require__(481);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(5448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(5448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 7288:
/***/ (function(module) {

module.exports = {
  "version": "0.24.0"
};

/***/ }),

/***/ 1849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 5327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 1793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 6268:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ 7985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 6016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 4109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(4867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 4875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(7288).version);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 4867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(1849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ 1752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(8027)


/***/ }),

/***/ 3454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(7663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(4576);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "n_": function() { return /* binding */ addBreadcrumb; },
/* harmony export */   "uT": function() { return /* binding */ captureMessage; }
/* harmony export */ });
/* unused harmony exports captureCheckIn, captureEvent, configureScope, setContext, setExtra, setExtras, setTag, setTags, setUser, startTransaction */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5877);



// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, {
        captureContext: captureContext
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === "string" ? captureContext : undefined;
    var context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ function captureEvent(event, hint) {
    return getCurrentHub().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ function configureScope(callback) {
    getCurrentHub().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function addBreadcrumb(breadcrumb) {
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().addBreadcrumb(breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
    getCurrentHub().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function setExtras(extras) {
    getCurrentHub().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function setExtra(key, extra) {
    getCurrentHub().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function setTags(tags) {
    getCurrentHub().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function setTag(key, value) {
    getCurrentHub().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function setUser(user) {
    getCurrentHub().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ function withScope(callback) {
    (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ function startTransaction(context, customSamplingContext) {
    return getCurrentHub().startTransaction(_object_spread({}, context), customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function captureCheckIn(checkIn, upsertMonitorConfig) {
    var client = getCurrentHub().getClient();
    if (!client) {
        ( false) && 0;
    } else if (!client.captureCheckIn) {
        ( false) && 0;
    } else {
        return client.captureCheckIn(checkIn, upsertMonitorConfig);
    }
    return uuid4();
}
 //# sourceMappingURL=exports.js.map


/***/ }),

/***/ 5877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gd": function() { return /* binding */ getCurrentHub; }
});

// UNUSED EXPORTS: API_VERSION, Hub, ensureHubOnCarrier, getHubFromCarrier, getMainCarrier, makeMain, runWithAsyncContext, setAsyncContextStrategy, setHubOnCarrier

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(1532);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(6018);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(8369);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/logger.js


/** Prefix for logging strings */ var PREFIX = "Sentry Logger ";
var CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function consoleSandbox(callback) {
    if (!("console" in worldwide/* GLOBAL_OBJ */.n2)) {
        return callback();
    }
    var originalConsole = worldwide/* GLOBAL_OBJ.console */.n2.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    CONSOLE_LEVELS.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in originalConsole && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (false) {} else {
        CONSOLE_LEVELS.forEach(function(name) {
            logger[name] = function() {
                return undefined;
            };
        });
    }
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var logger;
if (false) {} else {
    logger = makeLogger();
}
 //# sourceMappingURL=logger.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/constants.js
var DEFAULT_ENVIRONMENT = "production";
 //# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var src_instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/is.js
// eslint-disable-next-line @typescript-eslint/unbound-method

var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function is_isError(wat) {
    switch(objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return is_isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function isBuiltin(wat, className) {
    return objectToString.call(wat) === "[object ".concat(className, "]");
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isErrorEvent(wat) {
    return isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMError(wat) {
    return isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMException(wat) {
    return isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isString(wat) {
    return isBuiltin(wat, "String");
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function is_isPrimitive(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPlainObject(wat) {
    return isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function is_isEvent(wat) {
    return typeof Event !== "undefined" && is_isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function is_isElement(wat) {
    return typeof Element !== "undefined" && is_isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isRegExp(wat) {
    return isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isSyntheticEvent(wat) {
    return isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function is_isNaN(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function is_isInstanceOf(wat, base) {
    try {
        return _instanceof(wat, base);
    } catch (_e) {
        return false;
    }
}
 //# sourceMappingURL=is.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js



/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var States;
(function(States) {
    /** Pending */ var PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ var RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ var REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function resolvedSyncPromise(value) {
    return new SyncPromise(function(resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function rejectedSyncPromise(reason) {
    return new SyncPromise(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var SyncPromise = /*#__PURE__*/ function() {
    "use strict";
    function SyncPromise(executor) {
        _classCallCheck(this, SyncPromise);
        SyncPromise.prototype.__init.call(this);
        SyncPromise.prototype.__init2.call(this);
        SyncPromise.prototype.__init3.call(this);
        SyncPromise.prototype.__init4.call(this);
        SyncPromise.prototype.__init5.call(this);
        SyncPromise.prototype.__init6.call(this);
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    _createClass(SyncPromise, [
        {
            key: "__init",
            value: function __init() {
                this._state = States.PENDING;
            }
        },
        {
            key: "__init2",
            value: function __init2() {
                this._handlers = [];
            }
        },
        {
            /** JSDoc */ key: "then",
            value: function then(onfulfilled, onrejected) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    _this._handlers.push([
                        false,
                        function(result) {
                            if (!onfulfilled) {
                                // TODO: ¯\_(ツ)_/¯
                                // TODO: FIXME
                                resolve(result);
                            } else {
                                try {
                                    resolve(onfulfilled(result));
                                } catch (e) {
                                    reject(e);
                                }
                            }
                        },
                        function(reason) {
                            if (!onrejected) {
                                reject(reason);
                            } else {
                                try {
                                    resolve(onrejected(reason));
                                } catch (e) {
                                    reject(e);
                                }
                            }
                        }, 
                    ]);
                    _this._executeHandlers();
                });
            }
        },
        {
            /** JSDoc */ key: "catch",
            value: function _catch(onrejected) {
                return this.then(function(val) {
                    return val;
                }, onrejected);
            }
        },
        {
            /** JSDoc */ key: "finally",
            value: function _finally(onfinally) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    var val;
                    var isRejected;
                    return _this.then(function(value) {
                        isRejected = false;
                        val = value;
                        if (onfinally) {
                            onfinally();
                        }
                    }, function(reason) {
                        isRejected = true;
                        val = reason;
                        if (onfinally) {
                            onfinally();
                        }
                    }).then(function() {
                        if (isRejected) {
                            reject(val);
                            return;
                        }
                        resolve(val);
                    });
                });
            }
        },
        {
            /** JSDoc */ key: "__init3",
            value: function __init3() {
                var _this = this;
                this._resolve = function(value) {
                    _this._setResult(States.RESOLVED, value);
                };
            }
        },
        {
            /** JSDoc */ key: "__init4",
            value: function __init4() {
                var _this = this;
                this._reject = function(reason) {
                    _this._setResult(States.REJECTED, reason);
                };
            }
        },
        {
            /** JSDoc */ key: "__init5",
            value: function __init5() {
                var _this = this;
                this._setResult = function(state, value) {
                    if (_this._state !== States.PENDING) {
                        return;
                    }
                    if (isThenable(value)) {
                        void value.then(_this._resolve, _this._reject);
                        return;
                    }
                    _this._state = state;
                    _this._value = value;
                    _this._executeHandlers();
                };
            }
        },
        {
            /** JSDoc */ key: "__init6",
            value: function __init6() {
                var _this = this;
                this._executeHandlers = function() {
                    if (_this._state === States.PENDING) {
                        return;
                    }
                    var cachedHandlers = _this._handlers.slice();
                    _this._handlers = [];
                    cachedHandlers.forEach(function(handler) {
                        if (handler[0]) {
                            return;
                        }
                        if (_this._state === States.RESOLVED) {
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            handler[1](_this._value);
                        }
                        if (_this._state === States.REJECTED) {
                            handler[2](_this._value);
                        }
                        handler[0] = true;
                    });
                };
            }
        }
    ]);
    return SyncPromise;
}();
 //# sourceMappingURL=syncpromise.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/object.js





/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") {
        try {
            markFunctionWrapped(wrapped, original);
        } catch (_Oo) {
        // This can throw if multiple fill happens on a global object like XMLHttpRequest
        // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, "__sentry_original__", original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function urlEncode(object) {
    return Object.keys(object).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(object[key]));
    }).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function convertToPlainObject(value) {
    if (isError(value)) {
        return _object_spread({
            message: value.message,
            name: value.name,
            stack: value.stack
        }, getOwnProperties(value));
    } else if (isEvent(value)) {
        var newObj = _object_spread({
            type: value.type,
            target: serializeEventTarget(value.target),
            currentTarget: serializeEventTarget(value.currentTarget)
        }, getOwnProperties(value));
        if (typeof CustomEvent !== "undefined" && isInstanceOf(value, CustomEvent)) {
            newObj.detail = value.detail;
        }
        return newObj;
    } else {
        return value;
    }
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return isElement(target) ? htmlTreeAsString(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        var extractedProps = {};
        for(var property in obj){
            if (Object.prototype.hasOwnProperty.call(obj, property)) {
                extractedProps[property] = obj[property];
            }
        }
        return extractedProps;
    } else {
        return {};
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function extractExceptionKeysForMessage(exception) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40;
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) {
        return "[object has no keys]";
    }
    if (keys[0].length >= maxLength) {
        return truncate(keys[0], maxLength);
    }
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return truncate(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    var memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
    if (isPlainObject(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        var memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) {
            return memoVal;
        }
        var returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(inputValue)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (typeof inputValue[key] !== "undefined") {
                    returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        var memoVal1 = memoizationMap.get(inputValue);
        if (memoVal1 !== undefined) {
            return memoVal1;
        }
        var returnValue1 = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue1);
        inputValue.forEach(function(item) {
            returnValue1.push(_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue1;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function objectify(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case (typeof wat === "undefined" ? "undefined" : _type_of(wat)) === "symbol" || (typeof wat === "undefined" ? "undefined" : _type_of(wat)) === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case isPrimitive(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
 //# sourceMappingURL=object.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/session.js

/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    var startingTime = (0,time/* timestampInSeconds */.ph)();
    var session = {
        sid: (0,misc/* uuid4 */.DM)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: function() {
            return sessionToJSON(session);
        }
    };
    if (context) {
        updateSession(session, context);
    }
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function updateSession(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) {
            session.ipAddress = context.user.ip_address;
        }
        if (!session.did && !context.did) {
            session.did = context.user.id || context.user.email || context.user.username;
        }
    }
    session.timestamp = context.timestamp || (0,time/* timestampInSeconds */.ph)();
    if (context.ignoreDuration) {
        session.ignoreDuration = context.ignoreDuration;
    }
    if (context.sid) {
        // Good enough uuid validation. — Kamil
        session.sid = context.sid.length === 32 ? context.sid : (0,misc/* uuid4 */.DM)();
    }
    if (context.init !== undefined) {
        session.init = context.init;
    }
    if (!session.did && context.did) {
        session.did = "".concat(context.did);
    }
    if (typeof context.started === "number") {
        session.started = context.started;
    }
    if (session.ignoreDuration) {
        session.duration = undefined;
    } else if (typeof context.duration === "number") {
        session.duration = context.duration;
    } else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) {
        session.release = context.release;
    }
    if (context.environment) {
        session.environment = context.environment;
    }
    if (!session.ipAddress && context.ipAddress) {
        session.ipAddress = context.ipAddress;
    }
    if (!session.userAgent && context.userAgent) {
        session.userAgent = context.userAgent;
    }
    if (typeof context.errors === "number") {
        session.errors = context.errors;
    }
    if (context.status) {
        session.status = context.status;
    }
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function closeSession(session, status) {
    var context = {};
    if (status) {
        context = {
            status: status
        };
    } else if (session.status === "ok") {
        context = {
            status: "exited"
        };
    }
    updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function sessionToJSON(session) {
    return dropUndefinedKeys({
        sid: "".concat(session.sid),
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? "".concat(session.did) : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}
 //# sourceMappingURL=session.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/scope.js









/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ var DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var scope_Scope = /*#__PURE__*/ function() {
    "use strict";
    function Scope() {
        _classCallCheck(this, Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
    }
    _createClass(Scope, [
        {
            /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setUser",
            value: function setUser(user) {
                this._user = user || {};
                if (this._session) {
                    updateSession(this._session, {
                        user: user
                    });
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getRequestSession",
            value: function getRequestSession() {
                return this._requestSession;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setRequestSession",
            value: function setRequestSession(requestSession) {
                this._requestSession = requestSession;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = (0,src_object_spread/* default */.Z)({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTag",
            value: function setTag(key, value) {
                this._tags = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this._tags), (0,_define_property/* default */.Z)({}, key, value));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = (0,src_object_spread/* default */.Z)({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this._extra), (0,_define_property/* default */.Z)({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setLevel",
            value: function setLevel(// eslint-disable-next-line deprecation/deprecation
            level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) {
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this._contexts[key];
                } else {
                    this._contexts[key] = context;
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setSpan",
            value: function setSpan(span) {
                this._span = span;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getSpan",
            value: function getSpan() {
                return this._span;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getTransaction",
            value: function getTransaction() {
                // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
                // have a pointer to the currently-active transaction.
                var span = this.getSpan();
                return span && span.transaction;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) {
                    delete this._session;
                } else {
                    this._session = session;
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) {
                    return this;
                }
                if (typeof captureContext === "function") {
                    var updatedScope = captureContext(this);
                    return (0,src_instanceof/* default */.Z)(updatedScope, Scope) ? updatedScope : this;
                }
                if ((0,src_instanceof/* default */.Z)(captureContext, Scope)) {
                    this._tags = (0,src_object_spread/* default */.Z)({}, this._tags, captureContext._tags);
                    this._extra = (0,src_object_spread/* default */.Z)({}, this._extra, captureContext._extra);
                    this._contexts = (0,src_object_spread/* default */.Z)({}, this._contexts, captureContext._contexts);
                    if (captureContext._user && Object.keys(captureContext._user).length) {
                        this._user = captureContext._user;
                    }
                    if (captureContext._level) {
                        this._level = captureContext._level;
                    }
                    if (captureContext._fingerprint) {
                        this._fingerprint = captureContext._fingerprint;
                    }
                    if (captureContext._requestSession) {
                        this._requestSession = captureContext._requestSession;
                    }
                } else if (isPlainObject(captureContext)) {
                    // eslint-disable-next-line no-param-reassign
                    captureContext = captureContext;
                    this._tags = (0,src_object_spread/* default */.Z)({}, this._tags, captureContext.tags);
                    this._extra = (0,src_object_spread/* default */.Z)({}, this._extra, captureContext.extra);
                    this._contexts = (0,src_object_spread/* default */.Z)({}, this._contexts, captureContext.contexts);
                    if (captureContext.user) {
                        this._user = captureContext.user;
                    }
                    if (captureContext.level) {
                        this._level = captureContext.level;
                    }
                    if (captureContext.fingerprint) {
                        this._fingerprint = captureContext.fingerprint;
                    }
                    if (captureContext.requestSession) {
                        this._requestSession = captureContext.requestSession;
                    }
                }
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clear",
            value: function clear() {
                this._breadcrumbs = [];
                this._tags = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = undefined;
                this._transactionName = undefined;
                this._fingerprint = undefined;
                this._requestSession = undefined;
                this._span = undefined;
                this._session = undefined;
                this._notifyScopeListeners();
                this._attachments = [];
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
                // No data has been changed, so don't notify scope listeners
                if (maxCrumbs <= 0) {
                    return this;
                }
                var mergedBreadcrumb = (0,src_object_spread/* default */.Z)({
                    timestamp: (0,time/* dateTimestampInSeconds */.yW)()
                }, breadcrumb);
                this._breadcrumbs = (0,_to_consumable_array/* default */.Z)(this._breadcrumbs).concat([
                    mergedBreadcrumb
                ]).slice(-maxCrumbs);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getAttachments",
            value: function getAttachments() {
                return this._attachments;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ key: "applyToEvent",
            value: function applyToEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this._extra && Object.keys(this._extra).length) {
                    event.extra = (0,src_object_spread/* default */.Z)({}, this._extra, event.extra);
                }
                if (this._tags && Object.keys(this._tags).length) {
                    event.tags = (0,src_object_spread/* default */.Z)({}, this._tags, event.tags);
                }
                if (this._user && Object.keys(this._user).length) {
                    event.user = (0,src_object_spread/* default */.Z)({}, this._user, event.user);
                }
                if (this._contexts && Object.keys(this._contexts).length) {
                    event.contexts = (0,src_object_spread/* default */.Z)({}, this._contexts, event.contexts);
                }
                if (this._level) {
                    event.level = this._level;
                }
                if (this._transactionName) {
                    event.transaction = this._transactionName;
                }
                // We want to set the trace context for normal events only if there isn't already
                // a trace context on the event. There is a product feature in place where we link
                // errors with transaction and it relies on that.
                if (this._span) {
                    event.contexts = (0,src_object_spread/* default */.Z)({
                        trace: this._span.getTraceContext()
                    }, event.contexts);
                    var transaction = this._span.transaction;
                    if (transaction) {
                        event.sdkProcessingMetadata = (0,src_object_spread/* default */.Z)({
                            dynamicSamplingContext: transaction.getDynamicSamplingContext()
                        }, event.sdkProcessingMetadata);
                        var transactionName = transaction.name;
                        if (transactionName) {
                            event.tags = (0,src_object_spread/* default */.Z)({
                                transaction: transactionName
                            }, event.tags);
                        }
                    }
                }
                this._applyFingerprint(event);
                event.breadcrumbs = (0,_to_consumable_array/* default */.Z)(event.breadcrumbs || []).concat((0,_to_consumable_array/* default */.Z)(this._breadcrumbs));
                event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
                event.sdkProcessingMetadata = (0,src_object_spread/* default */.Z)({}, event.sdkProcessingMetadata, this._sdkProcessingMetadata);
                return this._notifyEventProcessors((0,_to_consumable_array/* default */.Z)(getGlobalEventProcessors()).concat((0,_to_consumable_array/* default */.Z)(this._eventProcessors)), event, hint);
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = (0,src_object_spread/* default */.Z)({}, this._sdkProcessingMetadata, newData);
                return this;
            }
        },
        {
            /**
   * This will be called after {@link applyToEvent} is finished.
   */ key: "_notifyEventProcessors",
            value: function _notifyEventProcessors(processors, event, hint) {
                var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    var processor = processors[index];
                    if (event === null || typeof processor !== "function") {
                        resolve(event);
                    } else {
                        var result = processor((0,src_object_spread/* default */.Z)({}, event), hint);
                         false && 0;
                        if (isThenable(result)) {
                            void result.then(function(final) {
                                return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                            }).then(null, reject);
                        } else {
                            void _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
                        }
                    }
                });
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                // We need this check for this._notifyingListeners to be able to work on scope during updates
                // If this check is not here we'll produce endless recursion when something is done with the scope
                // during the callback.
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        },
        {
            /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ key: "_applyFingerprint",
            value: function _applyFingerprint(event) {
                // Make sure it's an array first and we actually have something in place
                event.fingerprint = event.fingerprint ? (0,misc/* arrayify */.lE)(event.fingerprint) : [];
                // If we have something on the scope, then merge it with event
                if (this._fingerprint) {
                    event.fingerprint = event.fingerprint.concat(this._fingerprint);
                }
                // If we have no data at all, remove empty array default
                if (event.fingerprint && !event.fingerprint.length) {
                    delete event.fingerprint;
                }
            }
        }
    ], [
        {
            key: "clone",
            value: /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ function clone(scope) {
                var newScope = new Scope();
                if (scope) {
                    newScope._breadcrumbs = (0,_to_consumable_array/* default */.Z)(scope._breadcrumbs);
                    newScope._tags = (0,src_object_spread/* default */.Z)({}, scope._tags);
                    newScope._extra = (0,src_object_spread/* default */.Z)({}, scope._extra);
                    newScope._contexts = (0,src_object_spread/* default */.Z)({}, scope._contexts);
                    newScope._user = scope._user;
                    newScope._level = scope._level;
                    newScope._span = scope._span;
                    newScope._session = scope._session;
                    newScope._transactionName = scope._transactionName;
                    newScope._fingerprint = scope._fingerprint;
                    newScope._eventProcessors = (0,_to_consumable_array/* default */.Z)(scope._eventProcessors);
                    newScope._requestSession = scope._requestSession;
                    newScope._attachments = (0,_to_consumable_array/* default */.Z)(scope._attachments);
                    newScope._sdkProcessingMetadata = (0,src_object_spread/* default */.Z)({}, scope._sdkProcessingMetadata);
                }
                return newScope;
            }
        }
    ]);
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function getGlobalEventProcessors() {
    return (0,worldwide/* getGlobalSingleton */.YO)("globalEventProcessors", function() {
        return [];
    });
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
 //# sourceMappingURL=scope.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/hub.js








/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var Hub = /*#__PURE__*/ function() {
    "use strict";
    function Hub(client) {
        var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new scope_Scope(), _version = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : API_VERSION;
        _classCallCheck(this, Hub);
        this._version = _version;
        this._stack = [
            {
                scope: scope
            }
        ];
        if (client) {
            this.bindClient(client);
        }
    }
    _createClass(Hub, [
        {
            /**
   * @inheritDoc
   */ key: "isOlderThan",
            value: function isOlderThan(version) {
                return this._version < version;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "bindClient",
            value: function bindClient(client) {
                var top = this.getStackTop();
                top.client = client;
                if (client && client.setupIntegrations) {
                    client.setupIntegrations();
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "pushScope",
            value: function pushScope() {
                // We want to clone the content of prev scope
                var scope = scope_Scope.clone(this.getScope());
                this.getStack().push({
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "popScope",
            value: function popScope() {
                if (this.getStack().length <= 1) return false;
                return !!this.getStack().pop();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "withScope",
            value: function withScope(callback) {
                var scope = this.pushScope();
                try {
                    callback(scope);
                } finally{
                    this.popScope();
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getClient",
            value: function getClient() {
                return this.getStackTop().client;
            }
        },
        {
            /** Returns the scope of the top stack. */ key: "getScope",
            value: function getScope() {
                return this.getStackTop().scope;
            }
        },
        {
            /** Returns the scope stack for domains or the process. */ key: "getStack",
            value: function getStack() {
                return this._stack;
            }
        },
        {
            /** Returns the topmost scope layer in the order domain > local > process. */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)();
                var syntheticException = new Error("Sentry syntheticException");
                this._withClient(function(client, scope) {
                    client.captureException(exception, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        originalException: exception,
                        syntheticException: syntheticException
                    }, hint), {
                        event_id: eventId
                    }), scope);
                });
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)();
                var syntheticException = new Error(message);
                this._withClient(function(client, scope) {
                    client.captureMessage(message, level, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        originalException: message,
                        syntheticException: syntheticException
                    }, hint), {
                        event_id: eventId
                    }), scope);
                });
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)();
                if (!event.type) {
                    this._lastEventId = eventId;
                }
                this._withClient(function(client, scope) {
                    client.captureEvent(event, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, hint), {
                        event_id: eventId
                    }), scope);
                });
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, hint) {
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                if (!client) return;
                var ref1 = client.getOptions && client.getOptions() || {}, _beforeBreadcrumb = ref1.beforeBreadcrumb, beforeBreadcrumb = _beforeBreadcrumb === void 0 ? null : _beforeBreadcrumb, _maxBreadcrumbs = ref1.maxBreadcrumbs, maxBreadcrumbs = _maxBreadcrumbs === void 0 ? DEFAULT_BREADCRUMBS : _maxBreadcrumbs;
                if (maxBreadcrumbs <= 0) return;
                var timestamp = (0,time/* dateTimestampInSeconds */.yW)();
                var mergedBreadcrumb = (0,src_object_spread/* default */.Z)({
                    timestamp: timestamp
                }, breadcrumb);
                var finalBreadcrumb = beforeBreadcrumb ? consoleSandbox(function() {
                    return beforeBreadcrumb(mergedBreadcrumb, hint);
                }) : mergedBreadcrumb;
                if (finalBreadcrumb === null) return;
                if (client.emit) {
                    client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
                }
                scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setUser",
            value: function setUser(user) {
                this.getScope().setUser(user);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTags",
            value: function setTags(tags) {
                this.getScope().setTags(tags);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtras",
            value: function setExtras(extras) {
                this.getScope().setExtras(extras);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTag",
            value: function setTag(key, value) {
                this.getScope().setTag(key, value);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this.getScope().setExtra(key, extra);
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setContext",
            value: function setContext(name, context) {
                this.getScope().setContext(name, context);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "configureScope",
            value: function configureScope(callback) {
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                if (client) {
                    callback(scope);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "run",
            value: function run(callback) {
                var oldHub = makeMain(this);
                try {
                    callback(this);
                } finally{
                    makeMain(oldHub);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                var client = this.getClient();
                if (!client) return null;
                try {
                    return client.getIntegration(integration);
                } catch (_oO) {
                    ( false) && 0;
                    return null;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "startTransaction",
            value: function startTransaction(context, customSamplingContext) {
                var result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
                if (false) {}
                return result;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "traceHeaders",
            value: function traceHeaders() {
                return this._callExtensionMethod("traceHeaders");
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureSession",
            value: function captureSession() {
                var endSession = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                // both send the update and pull the session from the scope
                if (endSession) {
                    return this.endSession();
                }
                // only send the update
                this._sendSessionUpdate();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "endSession",
            value: function endSession() {
                var layer = this.getStackTop();
                var scope = layer.scope;
                var session = scope.getSession();
                if (session) {
                    closeSession(session);
                }
                this._sendSessionUpdate();
                // the session is over; take it off of the scope
                scope.setSession();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "startSession",
            value: function startSession(context) {
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                var ref1 = client && client.getOptions() || {}, release = ref1.release, _environment = ref1.environment, environment = _environment === void 0 ? DEFAULT_ENVIRONMENT : _environment;
                // Will fetch userAgent if called from browser sdk
                var userAgent = (worldwide/* GLOBAL_OBJ.navigator */.n2.navigator || {}).userAgent;
                var session = makeSession((0,src_object_spread/* default */.Z)({
                    release: release,
                    environment: environment,
                    user: scope.getUser()
                }, userAgent && {
                    userAgent: userAgent
                }, context));
                // End existing session if there's one
                var currentSession = scope.getSession && scope.getSession();
                if (currentSession && currentSession.status === "ok") {
                    updateSession(currentSession, {
                        status: "exited"
                    });
                }
                this.endSession();
                // Afterwards we set the new session on the scope
                scope.setSession(session);
                return session;
            }
        },
        {
            /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ key: "shouldSendDefaultPii",
            value: function shouldSendDefaultPii() {
                var client = this.getClient();
                var options = client && client.getOptions();
                return Boolean(options && options.sendDefaultPii);
            }
        },
        {
            /**
   * Sends the current Session on the scope
   */ key: "_sendSessionUpdate",
            value: function _sendSessionUpdate() {
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                var session = scope.getSession();
                if (session && client && client.captureSession) {
                    client.captureSession(session);
                }
            }
        },
        {
            /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ key: "_withClient",
            value: function _withClient(callback) {
                var ref = this.getStackTop(), scope = ref.scope, client = ref.client;
                if (client) {
                    callback(client, scope);
                }
            }
        },
        {
            /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "_callExtensionMethod",
            value: function _callExtensionMethod(method) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var carrier = getMainCarrier();
                var sentry = carrier.__SENTRY__;
                if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") {
                    return sentry.extensions[method].apply(this, args);
                }
                ( false) && 0;
            }
        }
    ]);
    return Hub;
}();
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function getMainCarrier() {
    worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ = worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return worldwide/* GLOBAL_OBJ */.n2;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        var hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) {
            return hub;
        }
    }
    // Return hub that lives on a global object
    return getGlobalHub(registry);
}
function getGlobalHub() {
    var registry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function ensureHubOnCarrier(carrier) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getGlobalHub();
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(carrier) || getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
        var globalHubTopStack = parent.getStackTop();
        setHubOnCarrier(carrier, new Hub(globalHubTopStack.client, Scope.clone(globalHubTopStack.scope)));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function runWithAsyncContext(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    }
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function getHubFromCarrier(carrier) {
    return (0,worldwide/* getGlobalSingleton */.YO)("hub", function() {
        return new Hub();
    }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function setHubOnCarrier(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}
 //# sourceMappingURL=hub.js.map


/***/ }),

/***/ 1466:
/***/ (function() {

"use strict";
var _sentryCollisionFreeGlobalObject =  false ? 0 : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/monitoring";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "FZoj212pq__MKP7BMoqa6"
};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";



/***/ }),

/***/ 1532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, addExceptionTypeValue, checkOrSetAlreadyCaught, getEventDescription, parseSemver */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6042);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8369);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function uuid4() {
    var gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2;
    var crypto = gbl.crypto || gbl.msCrypto;
    if (crypto && crypto.randomUUID) {
        return crypto.randomUUID().replace(/-/g, "");
    }
    var getRandomByte = crypto && crypto.getRandomValues ? function() {
        return crypto.getRandomValues(new Uint8Array(1))[0];
    } : function() {
        return Math.random() * 16;
    };
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return ([
        1e7
    ] + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, function(c) {
        return (// eslint-disable-next-line no-bitwise
        c ^ (getRandomByte() & 15) >> c / 4).toString(16);
    });
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return "".concat(firstException.type, ": ").concat(firstException.value);
        }
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) {
        firstException.value = value || "";
    }
    if (!firstException.type) {
        firstException.type = type || "Error";
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && "data" in newMechanism) {
        var mergedData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, currentMechanism && currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function addContextToFrame(lines, frame) {
    var linesOfContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) {
        return;
    }
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return snipLine(line, 0);
    });
    frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return snipLine(line, 0);
    });
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        addNonEnumerableProperty(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function arrayify(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}
 //# sourceMappingURL=misc.js.map


/***/ }),

/***/ 9097:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; }
});

// UNUSED EXPORTS: loadModule

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function getSDKSource() {
    // @ts-ignore "npm" is injected by rollup during build process
    return "npm";
}
 //# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(3454);

/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !isBrowserBundle() && Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, "process").cwd;
        mod = dynamicRequire(module, "".concat(cwd(), "/node_modules/").concat(moduleName));
    } catch (e1) {
    // no-empty
    }
    return mod;
}
 //# sourceMappingURL=node.js.map


/***/ }),

/***/ 6018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, browserPerformanceTimeOrigin, timestampWithMs, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9097);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8369);
/* module decorator */ module = __webpack_require__.hmd(module);


// eslint-disable-next-line deprecation/deprecation
var WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = WINDOW.performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ var timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ var usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = WINDOW.performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
}();
 //# sourceMappingURL=time.js.map


/***/ }),

/***/ 8369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ var GLOBAL_OBJ = typeof globalThis == "object" && isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
 true && isGlobalObj(window) || typeof self == "object" && isGlobalObj(self) || typeof __webpack_require__.g == "object" && isGlobalObj(__webpack_require__.g) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function getGlobalObject() {
    return GLOBAL_OBJ;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function getGlobalSingleton(name, creator, obj) {
    var gbl = obj || GLOBAL_OBJ;
    var __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
 //# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 9250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Banner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/utils/cookies.js
/* eslint-disable eqeqeq */ /* eslint-disable no-param-reassign */ /* eslint-disable no-plusplus */ /* eslint-disable camelcase */ function setCookie(name, value, exdays, path, global) {
    value = escape(value);
    if (exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        value += "; expires=".concat(exdate.toUTCString());
    }
    if (global) {
        value += "; domain=.".concat(window.location.hostname.replace(/^([^.]*\.)*([^.]+)((\.[^.]+){2})$/, "$2$3"));
    }
    value += "; path=".concat(path || "/");
    document.cookie = "".concat(name, " = ").concat(value);
}
function getCookie(c_name) {
    var i;
    var x;
    var y;
    var ARRcookies = document.cookie.split(";");
    for(i = 0; i < ARRcookies.length; i++){
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
            return unescape(y);
        }
    }
    return false;
}
var dateCheck = function(from, to, check) {
    var fDate = Date.parse(from);
    var lDate = Date.parse(to);
    var cDate = Date.parse(check);
    if (cDate <= lDate && cDate >= fDate) return true;
    return false;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./src/components/Layout/Banner/styles.tsx




var VoteButton = function(_param) {
    var children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "min-h-[30px]items-center ml-4 inline-block w-full scale-100 rounded-[18px] bg-black px-4 py-1 text-center text-xs uppercase leading-4 tracking-[0.04rem] text-mglGray50 no-underline shadow-[0_0_0_0_rgba(0,_0,_0,_1)] transition-all duration-200 ease-ease tablet:px-4 tablet:py-2 tablet:text-sm tablet:leading-5 desktop:w-[initial] desktop:px-8 desktop:py-2 [&_strong]:flex [&_strong]:justify-center [&_strong]:text-center [&_strong]:text-xs [&_strong]:font-medium [&_strong]:uppercase [&_strong]:leading-4 [&_strong]:tracking-[0.04rem] [&_strong]:no-underline tablet:[&_strong]:text-sm tablet:[&_strong]:leading-5"
    }, rest), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./public/images/bf2026/link-external.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgLinkExternal(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M3.75 5h3.125v1.25H3.75v5h5V8.125H10v3.125a1.25 1.25 0 01-1.25 1.25h-5a1.25 1.25 0 01-1.25-1.25v-5A1.25 1.25 0 013.75 5zm6.634-1.25H7.5V2.5h5v5h-1.25V4.651L7.915 7.986l-.884-.883 3.353-3.353z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  })));
}
/* harmony default export */ var link_external = (SvgLinkExternal);
// EXTERNAL MODULE: ./src/styles/designSystemColors.ts
var designSystemColors = __webpack_require__(9642);
;// CONCATENATED MODULE: ./src/components/Layout/Banner/bannerData.ts

var isBlackFriday = function(banner) {
    return "variant" in banner && banner.variant === "bf2026";
};
// Evento novo na agenda de quem clica, com o conteúdo inteiro (não copia o evento de ninguém).
var AGENDA_TITLE = encodeURIComponent("\uD83E\uDD11 Live da Black Friday Canaltech 2026");
var AGENDA_BASE = "https://calendar.google.com/calendar/render?action=TEMPLATE&text=".concat(AGENDA_TITLE, "&ctz=America%2FSao_Paulo");
var agendaUrl = function(start, end, details) {
    return "".concat(AGENDA_BASE, "&dates=").concat(start, "%2F").concat(end, "&details=").concat(encodeURIComponent(details));
};
var AGENDA_DETAILS = 'Chegou o grande dia! Vem com a gente e acompanhe a cobertura ao vivo das melhores ofertas da Black Friday!!!<br>---<br><b>Acesse:</b> <a href="https://canaltech.com.br/live">https://canaltech.com.br/live</a>';
var AGENDA_LIVE_26 = agendaUrl("20261126T190000", "20261127T010000", "<b>\uD83E\uDD11 Live: Virada Black Friday Canaltech</b><br>".concat(AGENDA_DETAILS));
var AGENDA_LIVE_27 = agendaUrl("20261127T110000", "20261127T140000", "<b>\uD83E\uDD11 Live: Black Friday Canaltech</b><br>".concat(AGENDA_DETAILS));
var LIVE_URL = "https://canaltech.com.br/live/";
var bannerData = [
    {
        variant: "bf2026",
        name: "pre-bf2026",
        startDate: "2026-11-01T00:00:00-03:00",
        endDate: "2026-11-25T23:59:59-03:00",
        link: {
            url: AGENDA_LIVE_26
        },
        badge: "26/11",
        texts: {
            md: "N\xe3o perca a Black Friday 2026 do Canaltech!",
            sm: "N\xe3o perca: live da Black Friday 2026",
            buttonText: "Adicionar na agenda"
        }
    },
    {
        variant: "bf2026",
        name: "dia-bf2026",
        startDate: "2026-11-26T00:00:00-03:00",
        endDate: "2026-11-26T18:59:59-03:00",
        link: {
            url: AGENDA_LIVE_26
        },
        badge: "HOJE 19H",
        texts: {
            md: "\xc9 hoje, n\xe3o perca a nossa live da Black Friday!",
            sm: "Hoje: live da Black Friday 2026",
            buttonText: "Adicionar na agenda"
        }
    },
    {
        variant: "bf2026",
        name: "live-bf2026-primeira",
        startDate: "2026-11-26T19:00:00-03:00",
        endDate: "2026-11-27T02:00:59-03:00",
        link: {
            url: LIVE_URL
        },
        badge: "AO VIVO",
        live: true,
        texts: {
            md: "Estamos ao vivo: Black Friday Canaltech 2026!",
            sm: "Ao vivo: Black Friday Canaltech 2026!",
            buttonText: "Assistir \xe0 live"
        }
    },
    {
        variant: "bf2026",
        name: "dia-bf2026-entre-lives",
        startDate: "2026-11-27T02:01:00-03:00",
        endDate: "2026-11-27T10:59:59-03:00",
        link: {
            url: AGENDA_LIVE_27
        },
        badge: "HOJE 11H",
        texts: {
            md: "\xc9 hoje, n\xe3o perca a nossa live da Black Friday!",
            sm: "Hoje: live da Black Friday 2026",
            buttonText: "Adicionar na agenda"
        }
    },
    {
        variant: "bf2026",
        name: "live-bf2026-segunda",
        startDate: "2026-11-27T11:00:00-03:00",
        endDate: "2026-11-27T14:00:59-03:00",
        link: {
            url: LIVE_URL
        },
        badge: "AO VIVO",
        live: true,
        texts: {
            md: "Estamos ao vivo: Black Friday Canaltech 2026!",
            sm: "Ao vivo: Black Friday Canaltech 2026!",
            buttonText: "Assistir \xe0 live"
        }
    },
    {
        name: "premio-ct-2023",
        startDate: "12/11/2023 12:45",
        endDate: "01/31/2024 23:59",
        link: {
            url: "https://premio.canaltech.com.br/2023/?utm_source=canaltech&utm_medium=site-barra&utm_campaign=premio-canaltech"
        },
        color: {
            barColors: "linear-gradient(224deg, #a92fd8, #20bcfe)",
            textColor: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
            buttonBackground: designSystemColors/* mglGray.mglGray900 */.Ce.mglGray900,
            textButtonColor: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
            textBackground: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50
        },
        emphasis: {
            md: "PR\xcaMIO CANALTECH: ",
            sm: "PR\xcaMIO CANALTECH: Participe e Vote!",
            xs: "Vote no Pr\xeamio Canaltech!"
        },
        texts: {
            md: "escolha os melhores da tecnologia de 2023!",
            sm: "",
            xs: "",
            buttonText: "VOTAR AGORA!"
        }
    },
    {
        name: "premio-ct-2023-resultado-sorteio",
        startDate: "02/19/2024 12:30",
        endDate: "03/01/2024 23:59",
        link: {
            url: "https://premio.canaltech.com.br/2023/?utm_source=canaltech&utm_medium=site-barra&utm_campaign=sorteio-premio-canaltech"
        },
        color: {
            barColors: "linear-gradient(224deg, #20bcfe, #a92fd8)",
            textColor: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
            buttonBackground: designSystemColors/* mglGray.mglGray900 */.Ce.mglGray900,
            textButtonColor: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50,
            textBackground: designSystemColors/* mglGray.mglGray50 */.Ce.mglGray50
        },
        emphasis: {
            md: "",
            sm: "PR\xcaMIO CT! Resultado do Sorteio",
            xs: "Ver sorteados do Pr\xeamio"
        },
        texts: {
            md: "SAIU O RESULTADO DO SORTEIO DO PR\xcaMIO CANALTECH!",
            sm: "",
            xs: "",
            buttonText: "CONFERIR"
        }
    }, 
];

;// CONCATENATED MODULE: ./src/components/Layout/Banner/closedBannersScript.ts

var CLOSED_KEY_PREFIX = "ct-banner-closed:";
var NAMES_JSON = JSON.stringify(bannerData.map(function(param) {
    var name = param.name;
    return name;
}));
var PREFIX_LENGTH = CLOSED_KEY_PREFIX.length;
// Roda no <head> antes do paint: esconde a barra já fechada (e zera o espaço que ela abre nos irmãos) para não piscar nem pular 50px.
// Modo teste (mesma regra do Banner): ?banner-test=<nome existente> ou ?banner-show-all=true ignoram o "fechado".
// O nome é saneado antes de ir para o CSS.
var CLOSED_BANNERS_SCRIPT = "try{var p=new URLSearchParams(location.search);if(".concat(NAMES_JSON, ".indexOf(p.get('banner-test'))<0&&p.get('banner-show-all')!=='true'){var c='';for(var i=0;i<localStorage.length;i++){var k=localStorage.key(i);if(k&&k.indexOf('").concat(CLOSED_KEY_PREFIX, "')===0&&localStorage.getItem(k)==='1'){var n=k.slice(").concat(PREFIX_LENGTH, ").replace(/[^\\w-]/g,'');var s='[data-banner=\"'+n+'\"]';c+=s+'{display:none!important}'+s+'+div,'+s+'+div+div{margin-top:0!important}'+s+'+div+main{padding-top:0!important}';}}if(c){var e=document.createElement('style');e.id='ct-banner-closed';e.textContent=c;document.head.appendChild(e);}}}catch(e){}");

;// CONCATENATED MODULE: ./src/components/Layout/Banner/BlackFridayBar.tsx




function BlackFridayBar(param) {
    var banner = param.banner, isTestMode = param.isTestMode;
    var storageKey = CLOSED_KEY_PREFIX + banner.name;
    var ref = (0,react.useState)(false), closed = ref[0], setClosed = ref[1];
    // Fechar vale só para esta fase: a próxima fase tem outro name e volta a aparecer.
    // Em modo teste o fechado salvo é ignorado e o X fecha só nesta página.
    (0,react.useEffect)(function() {
        if (isTestMode) {
            setClosed(false);
            return;
        }
        try {
            setClosed(window.localStorage.getItem(storageKey) === "1");
        } catch (e) {
            setClosed(false);
        }
    }, [
        storageKey,
        isTestMode
    ]);
    var close = function() {
        setClosed(true);
        if (isTestMode) return;
        try {
            window.localStorage.setItem(storageKey, "1");
        } catch (e) {
        // storage bloqueado: fecha só nesta página
        }
    };
    if (closed) return null;
    // Com skin o placeholder do topo some (+div+main) e o conteúdo desce junto com o anúncio.
    // O Topo Mobile fixado por script externo (top:60px) desce para baixo da barra.
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        "data-banner": banner.name,
        className: "fixed left-0 top-0 z-[988] mt-[60px] h-[50px] min-h-[50px] w-full overflow-hidden bg-[#06122B] font-primary md:mt-0 tablet:pl-[60px] [&+div+div]:mt-[50px] [&+div+main]:pt-[50px] [&+div]:mt-[50px] [&~div>div:has(>[id$=topo-mobile])]:!top-[110px]",
        children: [
            isTestMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-red-500 absolute left-2 top-1 z-10 rounded px-2 py-1 text-[10px] font-bold text-white",
                children: [
                    "TESTE: ",
                    banner.name
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                href: banner.link.url,
                target: "_blank",
                rel: "noopener noreferrer",
                title: banner.texts.md,
                className: "flex h-full items-center justify-center gap-2 pl-3 pr-10 text-[13px] font-bold text-white no-underline max-[359px]:gap-1 max-[359px]:pl-2 tablet:gap-4 tablet:text-base",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/bf2026/black-friday.png",
                        alt: "Black Friday",
                        width: 242,
                        height: 100,
                        className: "mr-2 h-[25px] w-auto shrink-0 max-[359px]:mr-1 max-[359px]:h-[22px] tablet:mr-4 tablet:h-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "flex shrink-0 items-center gap-1 whitespace-nowrap text-[#5CFF7A]",
                        children: [
                            banner.live && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "h-2 w-2 animate-pulse rounded-full bg-[#FF3B3B]"
                            }),
                            banner.badge
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hidden desktop:inline",
                        children: banner.texts.md
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "hidden tablet:inline desktop:hidden",
                        children: banner.texts.sm
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-[#5CFF7A] px-3 py-1 text-xs font-bold text-[#06122B] tablet:text-sm",
                        children: [
                            banner.texts.buttonText,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_external, {
                                "aria-hidden": "true",
                                width: 14,
                                height: 14,
                                className: "shrink-0 max-[359px]:hidden"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                "aria-label": "Fechar aviso",
                onClick: close,
                className: "absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer border-0 bg-transparent p-2 text-xl leading-none text-[#D8E2FB] tablet:right-4",
                children: "\xd7"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute bottom-0 left-0 h-[3px] w-full bg-[linear-gradient(90deg,#2B80FD,#46BFBB,#61FE7A)]"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Layout/Banner/index.tsx







function Banner() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), testBanner = ref[0], setTestBanner = ref[1];
    var ref1 = (0,react.useState)(false), showAllBanners = ref1[0], setShowAllBanners = ref1[1];
    var ref2 = (0,react.useState)(0), now = ref2[0], setNow = ref2[1];
    var excludedRoutes = [
        "/live",
        "/oppo"
    ];
    var currentPath = (router === null || router === void 0 ? void 0 : router.pathname) || "";
    var shouldHideBanner = excludedRoutes.includes(currentPath);
    (0,react.useEffect)(function() {
        if (true) {
            var params = new URLSearchParams(window.location.search);
            var bannerTest = params.get("banner-test");
            var showAll = params.get("banner-show-all");
            setTestBanner(bannerTest);
            setShowAllBanners(showAll === "true");
        }
    }, []);
    // Re-renderiza quando a próxima borda da escala passa, para a fase trocar em aba aberta.
    // Acorda no máximo a cada 1h: setTimeout acima de ~24,8 dias estoura e vira 1ms.
    (0,react.useEffect)(function() {
        var current = Date.now();
        var next = bannerData.flatMap(function(banner) {
            return [
                Date.parse(banner.startDate),
                Date.parse(banner.endDate) + 1000
            ];
        }).filter(function(edge) {
            return edge > current;
        }).sort(function(a, b) {
            return a - b;
        })[0];
        if (!next) return undefined;
        var timer = setTimeout(function() {
            return setNow(Date.now());
        }, Math.min(next - current + 250, 60 * 60 * 1000));
        return function() {
            return clearTimeout(timer);
        };
    }, [
        now
    ]);
    if (shouldHideBanner) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: bannerData.map(function(banner) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            var isTestMode = testBanner === banner.name || showAllBanners;
            var bannerIsInactive = !dateCheck(banner.startDate, banner.endDate, new Date());
            var shouldShowBanner = isTestMode || !bannerIsInactive;
            if (isBlackFriday(banner)) {
                return shouldShowBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(BlackFridayBar, {
                    banner: banner,
                    isTestMode: isTestMode
                }, banner.name);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: shouldShowBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    style: {
                        background: banner.color.barColors
                    },
                    className: "fixed left-0 top-0 z-[988] mt-[60px] h-[50px] min-h-[50px] w-full overflow-hidden p-0 pl-0 text-mglGray50 md:mt-0 tablet:pl-[60px] [&+div+div]:mt-[50px] [&+div]:mt-[50px] [&_svg]:ml-[10px] [&_svg]:cursor-pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-auto my-0 flex h-full w-full max-w-full basis-full items-center justify-center px-[0.625rem] tablet:max-w-[83.3333%] tablet:basis-[83.3333%] desktop:px-0",
                        children: [
                            isTestMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bg-red-500 absolute left-2 top-1 rounded px-2 py-1 text-[10px] font-bold text-white",
                                children: [
                                    "TESTE: ",
                                    banner.name
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hidden items-center px-0 py-2 desktop:flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                        style: {
                                            color: banner.color.textBackground
                                        },
                                        className: "hidden items-center whitespace-pre-wrap font-medium desktop:flex",
                                        children: [
                                            ((ref = banner.emphasis) === null || ref === void 0 ? void 0 : ref.md) && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                className: "p-2",
                                                children: banner.emphasis.md
                                            }),
                                            " ",
                                            banner.texts.md
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VoteButton, {
                                        href: banner.link.url,
                                        target: "_blank",
                                        title: banner.texts.md,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            style: {
                                                color: banner.color.textButtonColor
                                            },
                                            children: banner.texts.buttonText
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden w-full items-center py-2 tablet:flex desktop:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VoteButton, {
                                    href: banner.link.url,
                                    target: "_blank",
                                    title: banner.texts.sm,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        style: {
                                            color: banner.color.textButtonColor
                                        },
                                        children: ((ref1 = banner.emphasis) === null || ref1 === void 0 ? void 0 : ref1.sm) || banner.texts.sm
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex w-full items-center px-0 py-2 tablet:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VoteButton, {
                                    href: (ref2 = banner.link) === null || ref2 === void 0 ? void 0 : ref2.url,
                                    target: "_blank",
                                    title: (ref3 = banner.texts) === null || ref3 === void 0 ? void 0 : ref3.xs,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        style: {
                                            color: banner.color.textButtonColor
                                        },
                                        children: ((ref4 = banner.emphasis) === null || ref4 === void 0 ? void 0 : ref4.xs) || ((ref5 = banner.texts) === null || ref5 === void 0 ? void 0 : ref5.xs)
                                    })
                                })
                            })
                        ]
                    })
                })
            }, banner.name);
        })
    });
}


/***/ }),

/***/ 187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ErrorPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function ErrorPage(param) {
    var statusCode = param.statusCode, _isGeneric = param.isGeneric, isGeneric = _isGeneric === void 0 ? false : _isGeneric;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mt-10 flex w-full flex-col items-center justify-center gap-6 bg-mglGray50",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                className: "text-center text-4xl font-medium",
                children: [
                    !isGeneric && "Erro",
                    " ",
                    statusCode
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-center text-base font-light",
                children: "Desculpe, n\xe3o foi poss\xedvel carregar a p\xe1gina solicitada!"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: "flex cursor-pointer items-center justify-center rounded-[18px] border border-deprecatedCTBlue bg-deprecatedCTBlue px-6 py-2 text-center text-mglGray50 no-underline transition-all duration-300 hover:border-mglGray900 hover:bg-mglGray900",
                href: "/",
                children: "ir para a p\xe1gina principal"
            })
        ]
    });
}


/***/ }),

/***/ 7970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GlobalContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9659);


function GlobalContainer(param) {
    var children = param.children, whiteBg = param.whiteBg, center = param.center, _useNavbar = param.useNavbar, useNavbar = _useNavbar === void 0 ? true : _useNavbar;
    var variants = {
        whiteBg: {
            true: "whiteBg [&.whiteBg]:bg-mglGray50",
            false: ""
        },
        center: {
            true: "center flex flex-col justify-center items-center [&.center]:h-screen [&.center]:py-10 [&.center]:px-0",
            false: ""
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("h-full w-full bg-mglGray100 ", useNavbar && "pl-0 pt-[60px] tablet:pl-[60px] tablet:pt-0", whiteBg != undefined && variants.whiteBg[whiteBg.toString()], center != undefined && variants.center[center.toString()]),
        children: children
    });
}


/***/ }),

/***/ 5923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useScriptsToRoute; }
/* harmony export */ });
function useScriptsToRoute(currentRoute) {
    var useMgid = true;
    var useGpt = true;
    var useMarfeel = true;
    var useGtm = true;
    var useNavbar = true;
    var useComscore = true;
    var useFullScreen = false;
    var useRun = true;
    var useCnn = true;
    var specifyId = undefined;
    switch(currentRoute){
        case "/guia-de-compras":
            useMgid = false;
            useGpt = false;
            useMarfeel = false;
            useComscore = false;
            useNavbar = false;
            useFullScreen = true;
            useRun = false;
            useCnn = true;
            specifyId = "GTM-PT37RWSC";
            break;
        case "/live":
            useMgid = false;
            useGpt = false;
            useMarfeel = false;
            useComscore = false;
            useCnn = false;
            useNavbar = false;
            useFullScreen = true;
            useRun = false;
            specifyId = "GTM-K9569WH2";
            break;
        case "/oppo":
            useMgid = false;
            useGpt = false;
            useMarfeel = false;
            useComscore = false;
            useCnn = false;
            useNavbar = false;
            useFullScreen = true;
            useRun = false;
            break;
        default:
            break;
    }
    // sobrescreve useCnn se for página de erro
    if (currentRoute === "/404" || currentRoute === "/500") {
        useCnn = false;
    }
    return {
        useMgid: useMgid,
        useGpt: useGpt,
        useMarfeel: useMarfeel,
        useCnn: useCnn,
        useGtm: useGtm,
        specifyId: specifyId,
        useNavbar: useNavbar,
        useComscore: useComscore,
        useRun: useRun,
        useFullScreen: useFullScreen
    };
}


/***/ }),

/***/ 976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useTransition; },
/* harmony export */   "c": function() { return /* binding */ TransitioningProvider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



var TransitioningContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)({});
function TransitioningProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isTransitioning = ref[0], setIsTransitioning = ref[1];
    var alreadyContainedMgid = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    var appendScriptMgid = function() {
        var existingComponentMobile = document.getElementById("mgidContainerCTmobile");
        var existingComponentDesktop = document.getElementById("mgidContainerCTdesktop");
        if (!existingComponentDesktop || !existingComponentMobile) return;
        var existingScriptMobile = document.getElementById("mgidScriptmobile");
        var existingScriptDesktop = document.getElementById("mgidScriptdesktop");
        if (existingScriptMobile && existingScriptDesktop) return;
        var divDesktop = document.createElement("div");
        divDesktop.id = "M901213ScriptRootC1525795";
        divDesktop.className = "mgidDesktop";
        var divMobile = document.createElement("div");
        divMobile.id = "M901213ScriptRootC1524573";
        divMobile.className = "mgidMobile";
        var scriptDesktop = document.createElement("script");
        scriptDesktop.id = "mgidScriptmobile";
        scriptDesktop.src = "https://jsc.mgid.com/c/a/canaltech.com.br.1525795.js";
        scriptDesktop.type = "text/javascript";
        scriptDesktop.async = true;
        scriptDesktop.defer = true;
        var scriptMobile = document.createElement("script");
        scriptMobile.id = "mgidScriptmobile";
        scriptMobile.src = "https://jsc.mgid.com/c/a/canaltech.com.br.1524573.js";
        scriptMobile.type = "text/javascript";
        scriptMobile.async = true;
        scriptMobile.defer = true;
        var mgidParentDesktop = document.getElementById("mgidContainerCTdesktop");
        mgidParentDesktop.appendChild(divDesktop);
        mgidParentDesktop.appendChild(scriptDesktop);
        var mgidParentMobile = document.getElementById("mgidContainerCTmobile");
        mgidParentMobile.appendChild(divMobile);
        mgidParentMobile.appendChild(scriptMobile);
    };
    var decreaseScriptMgid = function() {
        var mgidParentDesktop = document.getElementById("mgidScriptdesktop");
        if (!mgidParentDesktop) return;
        while(mgidParentDesktop && mgidParentDesktop.firstChild){
            mgidParentDesktop.removeChild(mgidParentDesktop.firstChild);
        }
        var mgidParentMobile = document.getElementById("mgidScriptmobile");
        if (!mgidParentMobile) return;
        while(mgidParentMobile && mgidParentMobile.firstChild){
            mgidParentMobile.removeChild(mgidParentMobile.firstChild);
        }
        appendScriptMgid();
    };
    var handleStartTransitioning = function() {
        setIsTransitioning(true);
        var existingComponentMgid = document.getElementById("mgidScriptmobile");
        alreadyContainedMgid.current = !!existingComponentMgid;
    };
    // Não dispara ViewContent: quem manda o page-view para a Conversions API é o
    // effect de `_app.tsx`, keyed por `router.asPath` — ele já cobre a carga inicial
    // E as navegações SPA. Disparar aqui também gerava 2 eventos por navegação, com
    // ids distintos (a Meta não deduplica) e contagem dobrada no Events Manager.
    var handleStopTransitioning = function(url) {
        var dataLayer = window.dataLayer;
        var sendVirtualNavegation = function() {
            return dataLayer.push({
                event: "virtualNavegation"
            });
        };
        var minDelay = new Promise(function(resolve) {
            return setTimeout(resolve, 2000);
        });
        var idleReady = new Promise(function(resolve) {
            if ("requestIdleCallback" in window) {
                requestIdleCallback(function() {
                    return resolve();
                }, {
                    timeout: 5000
                });
            } else {
                setTimeout(resolve, 2000);
            }
        });
        Promise.all([
            minDelay,
            idleReady
        ]).then(sendVirtualNavegation);
        setIsTransitioning(false);
        if (alreadyContainedMgid.current) decreaseScriptMgid();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        next_router__WEBPACK_IMPORTED_MODULE_1___default().events.on("routeChangeStart", handleStartTransitioning);
        next_router__WEBPACK_IMPORTED_MODULE_1___default().events.on("routeChangeComplete", handleStopTransitioning);
        return function() {
            next_router__WEBPACK_IMPORTED_MODULE_1___default().events.off("routeChangeStart", handleStartTransitioning);
            next_router__WEBPACK_IMPORTED_MODULE_1___default().events.off("routeChangeComplete", handleStopTransitioning);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TransitioningContext.Provider, {
        value: {
            isTransitioning: isTransitioning,
            handleStartTransitioning: handleStartTransitioning,
            handleStopTransitioning: handleStopTransitioning
        },
        children: children
    });
}
function useTransition() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(TransitioningContext);
    return context;
}


/***/ }),

/***/ 4576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ App; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(5800);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js + 9 modules
var hub = __webpack_require__(5877);
// EXTERNAL MODULE: ./src/hooks/useTransition.tsx
var useTransition = __webpack_require__(976);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
;// CONCATENATED MODULE: ./src/components/Layout/ProgressBar/index.tsx






function ProgressBar() {
    var ref = (0,react.useState)(30), progress = ref[0], setProgress = ref[1];
    var isTransitioning = (0,useTransition/* useTransition */.Y)().isTransitioning;
    var counter = (0,react.useRef)(0);
    var isMounted = isTransitioning || progress === 100 ? "bg-mglBlue400 opacity-100" : "bg-transparent opacity-0";
    (0,react.useEffect)(function() {
        if (!isTransitioning) {
            setProgress(100);
            setTimeout(function() {
                setProgress(30);
            }, 1000);
        } else {
            var changeProgress = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        setTimeout(function() {
                            if (progress >= 80 && progress < 90) {
                                setProgress(progress + 2);
                            }
                            if (progress >= 30 && progress < 80) {
                                setProgress(progress + 10);
                            }
                        }, 1000);
                        counter.current += 1;
                        return [
                            2
                        ];
                    });
                });
                return function changeProgress() {
                    return _ref.apply(this, arguments);
                };
            }();
            changeProgress();
        }
    }, [
        counter.current,
        isTransitioning
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,className/* default */.Z)("fixed left-0 top-0 z-[9999] h-1 transition-all duration-300 ease-ease", isMounted),
        style: {
            width: "".concat(progress, "%")
        },
        role: "progressbar",
        "aria-label": "Barra de carregamento",
        title: "Barra de carregamento"
    });
}
var ProgressBarMemo = /*#__PURE__*/ react.memo(ProgressBar, function() {
    return true;
});
/* harmony default export */ var Layout_ProgressBar = (ProgressBarMemo);

// EXTERNAL MODULE: ./src/components/Layout/GlobalContainer/index.tsx
var GlobalContainer = __webpack_require__(7970);
// EXTERNAL MODULE: ./src/components/Layout/Banner/index.tsx + 6 modules
var Banner = __webpack_require__(9250);
// EXTERNAL MODULE: ./src/components/Layout/ErrorPage/index.tsx
var ErrorPage = __webpack_require__(187);
// EXTERNAL MODULE: ./src/pages/global.css
var global = __webpack_require__(6047);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.scss
var swiper = __webpack_require__(9530);
// EXTERNAL MODULE: ./node_modules/swiper/components/pagination/pagination.min.css
var pagination_min = __webpack_require__(10);
// EXTERNAL MODULE: ./node_modules/swiper/components/navigation/navigation.min.css
var navigation_min = __webpack_require__(6539);
// EXTERNAL MODULE: ./node_modules/react-image-gallery/styles/css/image-gallery.css
var image_gallery = __webpack_require__(4153);
// EXTERNAL MODULE: ./src/pages/styles.scss
var styles = __webpack_require__(3852);
// EXTERNAL MODULE: ./src/hooks/useScriptsToRoute.ts
var useScriptsToRoute = __webpack_require__(5923);
// EXTERNAL MODULE: ./src/services/fbConvetionAPI.ts
var fbConvetionAPI = __webpack_require__(6982);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(264);
;// CONCATENATED MODULE: ./src/utils/marfeelLogger.ts



/**
 * Logger de diagnóstico do Marfeel SDK — observe-only.
 *
 * Silencioso por padrão. Liga via `?marfeelDebug=1` (persistido em localStorage para
 * sobreviver às navegações SPA) ou diretamente por `localStorage.marfeelDebug = '1'`.
 * Como o SDK do Marfeel só roda em produção, o gate é controlado em runtime no navegador,
 * sem precisar de deploy/env.
 *
 * Saídas quando habilitado: `console.info('[marfeel]', ...)` + breadcrumb no Sentry
 * (no-op seguro quando o Sentry não está inicializado, ex.: dev).
 */ var STORAGE_KEY = "marfeelDebug";
var QUERY_FLAG = "marfeelDebug=1";
function isMarfeelDebugEnabled() {
    if (false) {}
    try {
        var enabledByQuery = window.location.search.indexOf(QUERY_FLAG) > -1;
        // ligado por query param persiste, para seguir habilitado entre navegações SPA
        if (enabledByQuery) {
            window.localStorage.setItem(STORAGE_KEY, "1");
            return true;
        }
        return window.localStorage.getItem(STORAGE_KEY) === "1";
    } catch (e) {
        return false;
    }
}
function logMarfeelEvent(event) {
    var payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!isMarfeelDebugEnabled()) return;
    try {
        var data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            url: window.location.href,
            ts: Date.now()
        });
        // eslint-disable-next-line no-console
        console.info("[marfeel]", event, data);
        (0,esm_exports/* addBreadcrumb */.n_)({
            category: "marfeel",
            level: "info",
            message: event,
            data: data
        });
    } catch (e) {
    // diagnóstico nunca pode quebrar a página
    }
}

;// CONCATENATED MODULE: ./src/hooks/useMarfeelPageTracking.ts




var publicRuntimeConfig = config_default()().publicRuntimeConfig;
/**
 * Tratativa de page-view e experiences do Marfeel para a SPA (Next.js).
 *
 * Contrato (alinhado à doc oficial do Marfeel JS SDK):
 * - 1ª página (initial mount): o SDK já auto-rastreia o primeiro page-view E auto-dispara
 *   as experiences ao carregar. NÃO chamamos nada aqui — senão a página de entrada contaria
 *   2× o page-view e teria "duplicate experience delivery".
 * - Navegação SPA (virtual navigation): por rota nova, disparamos 1× cada, nesta ordem:
 *     1. `compass.trackNewPage()`        — registra o page-view da nova rota;
 *     2. `experiences.triggerExperiences()` — recarrega as experiences. DEVE vir DEPOIS do
 *        trackNewPage (a URL do trackNewPage tem precedência na resolução).
 *   A dependência é `router.asPath` (muda a cada navegação client-side), e não mais um
 *   estado de transição consumido fora do seu Provider — que era uma dependência morta
 *   (sempre `undefined`) e fazia o effect nunca re-disparar em rota nova.
 *
 * O SDK do Marfeel só é injetado em produção (ver `_document.tsx`), então o disparo é
 * gated por env. Quando o SDK não está presente, o push em `window.marfeel.cmd` é inócuo.
 *
 * Os logs são observe-only e silenciosos por padrão (ligam via `?marfeelDebug=1`).
 *
 * @param enabled Se o Marfeel está habilitado para a rota atual (ver `useScriptsToRoute`).
 */ function useMarfeelPageTracking(enabled) {
    var router = (0,next_router.useRouter)();
    // refs de diagnóstico (observe-only) — não alteram o comportamento de tracking
    var isFirstRenderRef = (0,react.useRef)(true);
    var fireCountRef = (0,react.useRef)(0);
    var isProduction = publicRuntimeConfig.NEXT_PUBLIC_ENVIRONMENT === "production";
    // probe de readiness do SDK (uma vez, só em debug): os callbacks de compass/experiences
    // só rodam quando o módulo correspondente terminou de carregar → confirma "SDK executou
    // nesta req" sem disparar tracking.
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        if (!isProduction || !isMarfeelDebugEnabled()) return;
        window === null || window === void 0 ? void 0 : (ref = window.marfeel) === null || ref === void 0 ? void 0 : (ref1 = ref.cmd) === null || ref1 === void 0 ? void 0 : ref1.push([
            "compass",
            function() {
                logMarfeelEvent("compass:ready", {
                    route: router.asPath
                });
            }, 
        ]);
        window === null || window === void 0 ? void 0 : (ref2 = window.marfeel) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.cmd) === null || ref3 === void 0 ? void 0 : ref3.push([
            "experiences",
            function() {
                logMarfeelEvent("experiences:ready", {
                    route: router.asPath
                });
            }, 
        ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        var route = router.asPath;
        var isInitialMount = isFirstRenderRef.current;
        var phase = isInitialMount ? "initial-mount" : "virtual-navigation";
        // só dispara em navegação SPA: na 1ª req o SDK já auto-rastreia (evita contar 2×).
        var willPush = isProduction && enabled && !isInitialMount;
        fireCountRef.current += 1;
        logMarfeelEvent("effect:fire", {
            phase: phase,
            fireCount: fireCountRef.current,
            route: route,
            useMarfeel: enabled,
            willPush: willPush
        });
        isFirstRenderRef.current = false;
        if (!willPush) return;
        logMarfeelEvent("trackNewPage:queued", {
            phase: phase,
            route: route
        });
        window === null || window === void 0 ? void 0 : (ref = window.marfeel) === null || ref === void 0 ? void 0 : (ref1 = ref.cmd) === null || ref1 === void 0 ? void 0 : ref1.push([
            "compass",
            function(compass) {
                logMarfeelEvent("trackNewPage:executed", {
                    phase: phase,
                    route: route
                });
                compass.trackNewPage();
            }, 
        ]);
        // Experiences: recarrega as experiences na nova rota SPA. Empilhado DEPOIS do
        // trackNewPage (a URL dele tem precedência) e também gated por willPush — na 1ª carga
        // o SDK já dispara sozinho, e chamar aqui causaria "duplicate experience delivery".
        logMarfeelEvent("triggerExperiences:queued", {
            phase: phase,
            route: route
        });
        window === null || window === void 0 ? void 0 : (ref2 = window.marfeel) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.cmd) === null || ref3 === void 0 ? void 0 : ref3.push([
            "experiences",
            function(experiences) {
                logMarfeelEvent("triggerExperiences:executed", {
                    phase: phase,
                    route: route
                });
                experiences.triggerExperiences();
            }, 
        ]);
    }, [
        router.asPath,
        enabled
    ]);
}

;// CONCATENATED MODULE: ./src/pages/_app.tsx





 //
















function App(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var ref;
    if (pageProps.newsPreview) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "viewport",
                            content: "width=device-width, initial-scale=1.0, shrink-to-fit=no, user-scalable=yes, maximum-scale=5.0, minimum-scale=0.86"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            className: "versionExt",
                            content: "2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
            ]
        });
    }
    var transaction = (ref = (0,hub/* getCurrentHub */.Gd)().getScope()) === null || ref === void 0 ? void 0 : ref.getTransaction();
    var appSpan = transaction && transaction.startChild({
        op: "app"
    });
    var router = (0,next_router.useRouter)();
    var currentPath = router.pathname;
    var cleanPath = currentPath.split("?")[0].replace(/\/$/, "");
    var ref1 = (0,useScriptsToRoute/* default */.Z)(cleanPath), useGpt = ref1.useGpt, useMarfeel = ref1.useMarfeel, useComscore = ref1.useComscore, useCnn = ref1.useCnn;
    // tracking de page-view do Marfeel: 1ª req é auto-rastreada pelo SDK; navegação SPA
    // dispara trackNewPage 1× por rota. Detalhes e logs observe-only vivem no próprio hook.
    useMarfeelPageTracking(useMarfeel);
    // `eventId` estável por navegação: gerado no useEffect (client-only) para não quebrar
    // o SSR de `/404`, `/500`, `/live` no runtime Node 16 (que não tem `crypto` global).
    // Regera a cada mudança de rota; re-renders na mesma rota mantêm o mesmo id, então
    // retries e re-executions do effect deduplicam na Meta (via Events Manager).
    var ref2 = (0,react.useState)(""), pageViewEventId = ref2[0], setPageViewEventId = ref2[1];
    (0,react.useEffect)(function() {
        setPageViewEventId(crypto.randomUUID());
    }, [
        router.asPath
    ]);
    (0,react.useEffect)(function() {
        if (!pageViewEventId) return;
        (0,fbConvetionAPI/* sendPageViewEventToFacebookAPI */.b)({
            eventSourceUrl: window.location.href,
            eventId: pageViewEventId
        });
    }, [
        pageViewEventId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "viewport",
                    content: "width=device-width, initial-scale=1.0, shrink-to-fit=no, user-scalable=yes"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(useTransition/* TransitioningProvider */.c, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_ProgressBar, {}),
                    useGpt && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        strategy: "afterInteractive",
                        async: true,
                        src: "https://securepubads.g.doubleclick.net/tag/js/gpt.js"
                    }),
                    useComscore && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        dangerouslySetInnerHTML: {
                            __html: 'var _comscore = _comscore || [];\n              _comscore.push({\n                c1: "2",\n                c2: "20572948",\n                options: {\n                  enableFirstPartyCookie: true,\n                  bypassUserConsentRequirementFor1PCookie: true\n                }\n              });\n              (function() {\n                var s = document.createElement("script"), el = document.getElementsByTagName("script")[0];\n                s.async = true;\n                s.src = "https://sb.scorecardresearch.com/cs/20572948/beacon.js";\n                el.parentNode.insertBefore(s, el);\n              })();'
                        }
                    }),
                    useComscore && /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://sb.scorecardresearch.com/p?c1=2&c2=20572948&cv=cv=4.4.0&cj=1",
                            alt: ""
                        })
                    }),
                    useCnn && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                        id: "cnn-partners-sdk-jg",
                        strategy: "afterInteractive",
                        async: true,
                        src: "https://www.cnnbrasil.com.br/partners_sdk/?enable=badge"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
                        fallback: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                        children: "Canaltech | Ooops. Algo deu errado"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GlobalContainer/* default */.Z, {
                                    whiteBg: true,
                                    center: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* default */.Z, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPage/* default */.Z, {
                                            isGeneric: true,
                                            statusCode: "Ooops! Algo deu errado. "
                                        })
                                    ]
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                    })
                ]
            }),
            appSpan && appSpan.finish()
        ]
    });
}


/***/ }),

/***/ 6982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ sendPageViewEventToFacebookAPI; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);



// Bate no proxy server-side (`/api/fb-capi`) — o token da Conversions API vive só no server.
//
// O `eventId` DEVE vir estável por intenção de page-view (mesma navegação → mesmo id).
// Quem chama é responsável por gerá-lo com `crypto.randomUUID()` no ponto onde a intenção
// nasce (ex: derivado de `useRouter().asPath` no effect que dispara o page-view). Se um hook
// re-executar por re-render ou o axios falhar e o caller tentar de novo, o id se repete e a
// Meta deduplica. Gerar dentro deste service, como estava, criaria id novo por chamada e
// duplicaria conversões no Events Manager.
var sendPageViewEventToFacebookAPI = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
        var eventSourceUrl, eventId, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    eventSourceUrl = param.eventSourceUrl, eventId = param.eventId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    // Trailing slash é obrigatório: com `trailingSlash: true` no Next, `/api/fb-capi` (sem barra)
                    // volta 301, e o browser converte POST→GET no redirect → evento nunca chega no handler.
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post("/api/fb-capi/", {
                            eventName: "ViewContent",
                            eventSourceUrl: eventSourceUrl,
                            eventId: eventId
                        }, {
                            timeout: 3000
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function sendPageViewEventToFacebookAPI(_) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 9642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ce": function() { return /* binding */ mglGray; },
/* harmony export */   "Db": function() { return /* binding */ mglBlue; },
/* harmony export */   "nv": function() { return /* binding */ ctup; },
/* harmony export */   "wz": function() { return /* binding */ cteletro; },
/* harmony export */   "xx": function() { return /* binding */ ctauto; }
/* harmony export */ });
/* unused harmony exports mglYellow, mglOrange, mglRed, mglPink, mglPurple, mglGreen */
var mglGray = {
    mglGray50: "#fafafa",
    mglGray100: "#f5f5f5",
    mglGray200: "#e5e5e5",
    mglGray300: "#d4d4d4",
    mglGray400: "#a3a3a3",
    mglGray500: "#737373",
    mglGray600: "#525252",
    mglGray700: "#404040",
    mglGray800: "#262626",
    mglGray900: "#171717"
};
var mglBlue = {
    mglBlue50: "#E5F3FF",
    mglBlue100: "#B3DBFF",
    mglBlue200: "#80C2FF",
    mglBlue300: "#339EFF",
    mglBlue400: "#0086ff",
    mglBlue500: "#0079E6",
    mglBlue600: "#006BCC",
    mglBlue700: "#005099",
    mglBlue800: "#003666",
    mglBlue900: "#001b33"
};
var mglYellow = {
    mglYellow50: "#fffae2",
    mglYellow100: "#fff1af",
    mglYellow200: "#ffe87c",
    mglYellow300: "#ffdb30",
    mglYellow400: "#fcd000",
    mglYellow500: "#fcd000",
    mglYellow600: "#c9a600",
    mglYellow700: "#967c00",
    mglYellow800: "#635200",
    mglYellow900: "#302800"
};
var mglOrange = {
    mglOrange50: "#fff3e5",
    mglOrange100: "#ffdcb3",
    mglOrange200: "#ffc480",
    mglOrange300: "#ffa133",
    mglOrange400: "#ff8a00",
    mglOrange500: "#E67C00",
    mglOrange600: "#CC6E00",
    mglOrange700: "#995300",
    mglOrange800: "#663700",
    mglOrange900: "#331C00"
};
var mglRed = {
    mglRed50: "#fff1f2",
    mglRed100: "#ffd7db",
    mglRed200: "#ffa4ad",
    mglRed300: "#ff5868",
    mglRed400: "#ff253a",
    mglRed500: "#ff0b23",
    mglRed600: "#f10017",
    mglRed700: "#D70015",
    mglRed800: "#BE0012",
    mglRed900: "#A40010"
};
var mglPink = {
    mglPink50: "#ffe9f6",
    mglPink100: "#ffd0ea",
    mglPink200: "#FFB6DF",
    mglPink300: "#ff83c9",
    mglPink400: "#FF6ABE",
    mglPink500: "#ff1d9d",
    mglPink600: "#ff37a8",
    mglPink700: "#ff0491",
    mglPink800: "#d00076",
    mglPink900: "#b60067"
};
var mglPurple = {
    mglPurple50: "#F0C7FF",
    mglPurple100: "#E294FF",
    mglPurple200: "#D461FF",
    mglPurple300: "#C015FF",
    mglPurple400: "#A400E1",
    mglPurple500: "#9100c7",
    mglPurple600: "#7f00ae",
    mglPurple700: "#6c0094",
    mglPurple800: "#5a007b",
    mglPurple900: "#340048"
};
var mglGreen = {
    mglGreen50: "#BCFFBE",
    mglGreen100: "#89FF8C",
    mglGreen200: "#0AFF0F",
    mglGreen300: "#00D604",
    mglGreen400: "#00d604",
    mglGreen500: "#00BC04",
    mglGreen600: "#00a303",
    mglGreen700: "#007002",
    mglGreen800: "#003d01",
    mglGreen900: "#000a00"
};
var ctup = {
    ctupBlue: "#004BCC",
    ctupCyan: "#2ED5FF"
};
var cteletro = {
    cteletroGreen: "#2EC900",
    cteletroBlack: "#1C1C1C"
};
var ctauto = {
    ctautoRed: "#E0140F",
    ctautoBlack: "#1C1C1C"
};


/***/ }),

/***/ 9659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ classNames; }
/* harmony export */ });
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}


/***/ }),

/***/ 4153:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6539:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 10:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 6047:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9530:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3852:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(699)


/***/ }),

/***/ 5800:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(7294)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 4924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 2670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 6042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 9396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 9534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(1466), __webpack_exec__(6840), __webpack_exec__(387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);